import * as React from 'react'

import {IPrescriptionData} from 'core/api/patient'
import {UncontrolledPrescriptionDetails} from './prescription-details'
import * as styles from './prescription-history.css'

interface IProps {
  className?: string
  prescriptions: IPrescriptionData[]
}

interface IComponentState {
  expandPrescriptions: boolean
}

export class PrescriptionHistory extends React.PureComponent<IProps, IComponentState> {
  public state = {
    expandPrescriptions: false,
  }

  public render() {
    const {prescriptions} = this.props
    const {expandPrescriptions} = this.state
    const showPrescriptions = expandPrescriptions ? prescriptions : prescriptions.slice(0, 1)

    if (prescriptions.length <= 0) {
      return <p>No prescriptions found.</p>
    }

    return (
      <div className={styles.prescriptionsContainer}>
        <div>
          {showPrescriptions.map((p) => (
            <div key={p.id}>
              <h2 className={styles.prescriptionHeader}>{p.id.slice(0, 6)}</h2>
              <UncontrolledPrescriptionDetails prescription={p} />
            </div>
          ))}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/components/prescription/prescription-history.tsx